import { api } from "..";

interface DeleteCouponsPayload {
  couponIds: string[];
}

export const deleteCoupons = async ({ couponIds }: DeleteCouponsPayload) => {
  const res = await api.client.post(`/users-new/coupons/bulk-delete`, {
    couponIds,
  });
  return res.data;
};
